/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Loading_Saved_AddressesInputs */

const en_orders_loading_saved_addresses = /** @type {(inputs: Orders_Loading_Saved_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading saved addresses...`)
};

const es_orders_loading_saved_addresses = /** @type {(inputs: Orders_Loading_Saved_AddressesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando direcciones guardadas...`)
};

/**
* | output |
* | --- |
* | "Loading saved addresses..." |
*
* @param {Orders_Loading_Saved_AddressesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_loading_saved_addresses = /** @type {((inputs?: Orders_Loading_Saved_AddressesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Loading_Saved_AddressesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_loading_saved_addresses(inputs)
	return es_orders_loading_saved_addresses(inputs)
});